import { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { onIdTokenChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";

export function useAuth() {
  const [user, setUser] = useState(null);
  const [claims, setClaims] = useState({});
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let stopProfile = null;

    const unsub = onIdTokenChanged(auth, async (u) => {
      setUser(u);
      setClaims({});
      setProfile(null);

      if (!u) {
        if (stopProfile) stopProfile();
        setLoading(false);
        return;
      }

      // get fresh claims whenever the ID token changes
      const tok = await u.getIdTokenResult();
      setClaims(tok.claims || {});

      // live profile doc for UI
      if (stopProfile) stopProfile();
      stopProfile = onSnapshot(doc(db, "Users", u.uid), (snap) => {
        setProfile(snap.data() || null);
      });

      setLoading(false);
    });

    return () => {
      if (stopProfile) stopProfile();
      unsub();
    };
  }, []);

  return { user, claims, profile, loading };
}
